import { notification } from 'antd';

export type NotificationType = 'error' | 'success' | 'info' | 'warning';

export interface NotifierOptions {
  key?: string;
  description?: string;
  duration?: number;
}

export const notifier = (
  message: string,
  type: NotificationType,
  options: NotifierOptions = {},
) => {
  notification[type]({
    message,
    ...options,
  });
};
